import { render, staticRenderFns } from "./carplatematchrule.vue?vue&type=template&id=e1350b3a&scoped=true&"
import script from "./carplatematchrule.vue?vue&type=script&lang=js&"
export * from "./carplatematchrule.vue?vue&type=script&lang=js&"
import style0 from "./carplatematchrule.vue?vue&type=style&index=0&id=e1350b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1350b3a",
  null
  
)

export default component.exports